import L from 'leaflet'
import 'leaflet.markercluster/dist/leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import { useEffect } from 'react'
import { useLeaflet } from 'react-leaflet'

const mcg = L.markerClusterGroup({
    disableClusteringAtZoom: 16,
})

const MarkerCluster: React.FC<{ markers: any[] }> = (props) => {
    const { markers } = props
    const { map } = useLeaflet()

    useEffect(() => {
        mcg.clearLayers()
        markers.forEach((row: any) => {
            // const online = row.latest ? moment(row.latest.recordedAt).isBetween(moment().subtract({hours: hours}), moment()) : false
            // if(!row.location || (!row.location.latitude || !row.location.longitude)) return
            // return L.marker({ lat: row.location.latitude, lng: row.location.longitude }, {
            //     icon: online ? green : red,
            //   })
            // .addTo(mcg)
            // .bindPopup(row.title)
            row.addTo(mcg)
        })
        map!.addLayer(mcg)
    }, [markers, map])

    return null
}

export default MarkerCluster
